import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'aw-chip',
  imports: [CommonModule],
  templateUrl: './chip.component.html',
  styles: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  public readonly id: InputSignal<string> = input.required();
  public readonly text: InputSignal<string> = input.required();
  public readonly icon: InputSignal<string | undefined> = input<string>();
  public readonly appearance: InputSignal<
    'default' | 'neutral' | 'warning' | 'success' | 'error'
  > = input<'default' | 'neutral' | 'warning' | 'success' | 'error'>('default');
}
